// extracted by mini-css-extract-plugin
export var form = "formik-form-module--form--E7oYi";
export var formFieldset = "formik-form-module--form-fieldset--Bfoce";
export var globalErrorText = "formik-form-module--global-error-text--z376v";